<script lang="ts">
  import SettingsNotifications from "@modern/components/retailer/settings/Notifications.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";

  const load = async () => {
    return HttpPromise({
      method: "GET",
      url: "/api/retailer/notifications",
    });
  };

</script>

{#await load()}
  <Spinner />
{:then notificationsRes}
  <SettingsNotifications {notificationsRes} />
{/await}
